// src/main.ts
import "./map/styles/map.css";
import "./map/styles/sidebar.css";
import "./map/styles/searchbox.css";
import "./map/styles/toast.css";

import { addOrUpdateMarker } from "./map/markers/createMarker";
import { getStationById, getStations } from "./domain/storage/stationsStore";
import { connectSignalR } from "./services/signalr";
import { buildStationsFromMarkers } from "./map/data/searchIndex";
import { getMap, initilizeMap, showLoading } from "./map/initMap";
import { PortEntry } from "./domain/visuals/SearchControl";
import { flashElement } from "./domain/visuals/sidebar";
import { setupBarbiefyHotkey } from "./map/styles/barbiefy";

/* -----------------------------------------------------------
   Map init
----------------------------------------------------------- */
export function addAllStations() {
	const stations = getStations();
	let markers = [];
	for (const s of stations) {
		const m = addOrUpdateMarker(s, getMap().map, getMap().cluster);
		if (m !== undefined) {
			markers.push(m);
		}
	}
	const pinsIndex = buildStationsFromMarkers(markers);
	getMap().search.setStations(pinsIndex);
}

export function UpdateStationSamples(stationId: string) {
	const station = getStationById(stationId);
	const m = addOrUpdateMarker(station, getMap().map, getMap().cluster);
	flashElement(m?.getElement());
}
export function setPorts(ports: PortEntry[]) {
	getMap().search.setPorts(ports);
}
/* -----------------------------------------------------------
   Demo data loop (replace fetchLatest with your API)
----------------------------------------------------------- */
(async function boot() {
	if (import.meta.env.PROD && window.location.hostname.includes("breeze")) {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.innerHTML = `(function (c, l, a, r, i, t, y) {
			c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
			t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
			y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
		})(window, document, "clarity", "script", "vy3qu8b1fl");`
		document.head.appendChild(script);
	}


	const leafletMap = initilizeMap("map", 10);
	const updateZoomScale = leafletMap.updateZoomScale;
	setupBarbiefyHotkey();
	function updateViewportInsets() {
		const vv = (window as any).visualViewport;
		if (!vv) return; // older browsers: keep default 0

		// How much of the layout viewport is hidden by toolbars/gesture area
		const occludedBottom = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
		document.documentElement.style.setProperty('--vvb', `${occludedBottom}px`);
	}

	// initialize + keep updated
	if ((window as any).visualViewport) {
		updateViewportInsets();
		(window as any).visualViewport.addEventListener('resize', updateViewportInsets);
		(window as any).visualViewport.addEventListener('scroll', updateViewportInsets);
		window.addEventListener('orientationchange', updateViewportInsets);
	}
	showLoading("Connecting to Breeze Hub...");
	connectSignalR();
	updateZoomScale();
})();
